import classes from './ChatWidget.module.scss'
import { ChatCategory } from './types'

interface Props {
  categories: ChatCategory[]
}

/**
 * Marka kategorilerini, ürün listesini yeni sekmede açan chip listesi olarak gösterir. Yollar
 * sunucuda üretilir — bu bileşen adres kurmaz; yolu olmayan kategori pasif chip olarak kalır.
 * Kategoriler tekilleştirilmez: aynı adlı iki kategori farklı ürünler döndürür.
 */
export default function CategoryChips({ categories }: Props) {
  if (categories.length === 0) return null

  return (
    <nav className={classes.categoryChips} aria-label='Kategoriler'>
      {categories.map((category, index) => {
        const key = `${category.categoryId}-${index}`
        const label = (
          <>
            {category.name}
            {category.productCount !== null && (
              <span className={classes.categoryChipCount}>{category.productCount}</span>
            )}
          </>
        )

        // Yol yok/güvensiz → chip görünür ama tıklanamaz; aktive edilecek bir şey olmadığı için
        // klavye sırasında da yer almaz.
        if (category.path === null) {
          return (
            <span key={key} className={`${classes.categoryChip} ${classes.categoryChipOff}`} aria-disabled='true'>
              {label}
            </span>
          )
        }

        return (
          <a key={key} className={classes.categoryChip} href={category.path} target='_blank' rel='noopener noreferrer'>
            {label}
          </a>
        )
      })}
    </nav>
  )
}
